enum FeatureFlags {
  SupportRedirect = 'support-redirect',
  TerraformStack1IDM = '1-idm-terraform-stack',
}

export default FeatureFlags;
